import type { EventName } from "@lit/react";
import { GridFilter as GridFilterElement, type GridFilterEventMap as _GridFilterEventMap, } from "@vaadin/grid/vaadin-grid-filter.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { GridFilterElement, };
export type GridFilterEventMap = Readonly<{
    onValueChanged: EventName<_GridFilterEventMap["value-changed"]>;
}>;
const events = { onValueChanged: "value-changed" } as GridFilterEventMap;
export type GridFilterProps = WebComponentProps<GridFilterElement, GridFilterEventMap>;
export const GridFilter = createComponent({
    elementClass: GridFilterElement, events, react: React, tagName: "vaadin-grid-filter"
});
